export enum GameJackpot {
    SMALL_JACKPOT = 'SMALL_JACKPOT',
    SUPER_JACKPOT = 'SUPER_JACKPOT',
    MEGAPRIZE = 'MEGAPRIZE',
}

export type GameJackpotUnion = `${GameJackpot}`

export interface CombinedJackpotWebsocketResponse {
    games: CombinedJackpotWebsocket[]
}

export interface CombinedJackpotWebsocket {
    slug: string
    jackpot: string
}

export interface JackpotGame {
    slug: string
    type: GameJackpotUnion
    value: string
    jackpotPrettyName: string | null
}

export interface JackpotGameResponse {
    slug: string
    jackpots: JackpotGame[]
}

export interface JackpotGameMap {
    jackpot: number
    superJackpot: number
    megaprize: number
    /** Jackpot label set in the game configuration service; null when the game has none. */
    prettyName: string | null
}
